import { BASE_URL } from "../../../../App/Configs/AppConfig";
import ApiHelper from "../../../../App/Utils/APIHelper";
import { URLS, QUERY } from "../../../constants";
import { apiCall } from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import { METHOD_GET, METHOD_PATCH } from "swfrontend/COMS/Utils/ApiCommunicaton";

export default class RegistrationDataProvider {
  apiHelper = new ApiHelper(BASE_URL);

  registration_customer_api = async (values) =>
    await this.apiHelper.apiCall(URLS.CUSTOMER_REGISTRATION, "POST", values);

  update_customer_api = async (id, values) =>
    await this.apiHelper.apiCall(URLS.UPDATE_CUSTOMER + id, "PUT", values);

  init_change_request_api = async (id, values) =>
    await this.apiHelper.apiCall(URLS.INIT_CR_CUSTOMER + id, "POST", values);

  download_file_api = async (id) =>
    await this.apiHelper.apiCall(URLS.CUSTOMER_DOWNLOAD_FILE + id, "GET", null);

  get_all_fmes_api = async (q) =>
    await this.apiHelper.apiCall(URLS.FMES + q, "GET", null);

  get_user_data_api = async (id) =>
    await this.apiHelper.apiCall(URLS.GET_USERDATA + id, "GET", null);

  get_states_by_country_api = async (id) =>
    await this.apiHelper.apiCall(URLS.STATES + id, "GET", null);

  get_version_history_api = async (id) =>
    await this.apiHelper.apiCall(URLS.GET_VERSION_HISTORY + id, "GET", null);

  get_file_config_api = async () =>
    await this.apiHelper.apiCall(URLS.FILE_CONFIG, "GET", null);

  get_currency = async (country) =>
    await this.apiHelper.apiCall(URLS.CURRENCY + country, "GET", null);

  get_customer_fields_api = async (id) =>
    await this.apiHelper.apiCall(
      URLS.GET_REGISTRATION_FIELDS + "?user=" + id + "&crp",
      "GET",
      null
    );

  get_req_op_fields_api = async (id) =>
    await this.apiHelper.apiCall(URLS.GET_REQ_OP_FIELDS, "GET", null);

  get_dropdown_data_api = async (app, model) =>
    await this.apiHelper.apiCall(
      URLS.DROPDOWN +
        app +
        "." +
        model +
        apiCall.listViewCall +
        apiCall.dropDownCall,
      "GET",
      null
    );

  get_dependent_dropdown_data_api = async (app, model, dependent, id) =>
    await this.apiHelper.apiCall(
      URLS.DROPDOWN +
        app +
        "." +
        model +
        apiCall.listViewCall +
        apiCall.dropDownCall +
        "&" +
        dependent +
        "=" +
        id,
      "GET",
      null
    );

  get_type_of_industry_api = async (system) =>
    await this.apiHelper.apiCall(
      URLS.GET_INDUSTRIES + system,
      METHOD_GET,
      null
    );

  get_dependent_dropdown_default_value_api = async (
    app,
    model,
    dependent,
    id,
    source = ""
  ) =>
    await this.apiHelper.apiCall(
      URLS.DROPDOWN_BY_SOURCE +
        app +
        "." +
        model +
        apiCall.listViewCall +
        QUERY.by_source +
        source +
        QUERY.dependent +
        dependent +
        QUERY.id +
        id,
      METHOD_GET,
      null
    );

  get_data_by_prospectid_api = async (id) =>
    await this.apiHelper.apiCall(URLS.GET_DATA_BY_PROSPECTID + id, METHOD_GET, null);

  update_reverted_customer = async (_, values) =>
    await this.apiHelper.apiCall(URLS.UPDATE_REVERTED_CUSTOMER, METHOD_PATCH, values);

  generate_registration_otp = async (values) =>
    await this.apiHelper.apiCall(URLS.GENERATE_REGISTRATION_OTP, "POST", values);

  validate_registration_otp = async (values) =>
    await this.apiHelper.apiCall(URLS.VALIDATE_REGISTRATION_OTP, "POST", values);
}
